import { memo } from 'react';
import { useResponsive } from 'app/hooks';
import { IPublicRequestMetersData } from 'app/pages/request-single-page/request-single-page-slice';
import { MetersVariants } from '../../constants';
import {
  SVG,
  Text,
  Hint,
  HStack,
  VStack,
} from 'app/pages/request-single-page/components-v4';
import { useV4Theme } from 'app/pages/request-single-page/components-v4/theme';
import { Icons } from 'app/pages/request-single-page/components-v4/icons';
import { BadgeWrapper, IconWrapper } from '../meter.styled';
import { AutomaticIcon } from './automatic-icon';

export const MeterBadge = memo(
  ({
    type,
    serial_number,
    is_automatic,
    unit,
    last_readings,
  }: IPublicRequestMetersData) => {
    const theme = useV4Theme();
    const { viewport } = useResponsive();

    const { color, icon, readings: meterReadings } = MetersVariants[type.type];
    const isMultiRateMeter = meterReadings.length > 1;

    return (
      <BadgeWrapper>
        <HStack spacing="xs">
          <IconWrapper $isMobile={viewport.mobile} $colorVariant={color}>
            <SVG
              src={icon}
              props={{
                color: theme.colors[color][500],
              }}
            />
          </IconWrapper>

          <VStack flex={1} spacing="none">
            <HStack align="center" justify="space-between" spacing="xs">
              <HStack align="center" spacing="xxs">
                <Text variant={viewport.mobile ? 'body-14' : 'body-16'}>
                  {type.type_ru}
                </Text>

                {is_automatic && <AutomaticIcon />}
              </HStack>

              {!isMultiRateMeter && (
                <Text variant={viewport.mobile ? 'body-14' : 'body-16'}>
                  {last_readings[0]?.value ?? 0} {unit}
                </Text>
              )}
            </HStack>

            <Text
              variant={viewport.mobile ? 'body-14' : 'body-16'}
              color="gray.500"
            >
              {serial_number}
            </Text>
          </VStack>
        </HStack>

        {isMultiRateMeter && (
          <>
            {meterReadings.map(({ label }, index) => (
              <HStack align="center" justify="space-between" key={index}>
                <Text
                  variant={viewport.mobile ? 'body-14' : 'body-16'}
                  color="gray.500"
                >
                  {label}
                </Text>
                <Text variant={viewport.mobile ? 'body-14' : 'body-16'}>
                  {last_readings[index]?.value || 0} {unit}
                </Text>
              </HStack>
            ))}
          </>
        )}
      </BadgeWrapper>
    );
  }
);
